import { render, staticRenderFns } from "./ArrowDown10Icon.vue?vue&type=template&id=0830657a"
import script from "./ArrowDown10Icon.vue?vue&type=script&lang=js"
export * from "./ArrowDown10Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports